module.exports = __webpack_public_path__ + "static/media/coming_soon.58be0033.png";